// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/allproducts/Estaar3.png";
import thumb1 from "../assets/images/All-Products/eStaar.png";
import thumb2 from "../assets/images/allproducts/Estaar3.png";
import thumb3 from "../assets/images/All-Products/eStaar.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>eStaar </h2>
              <p className="sub-heading text-muted">Effective treatment for scalp psoriasis.</p>
              <h5>Product Overview</h5>
              <p>
                <ul>
                  <li>eStaar solution is an anti-dandruff solution which contains coal tar and salicylic acid.</li>
                  <li>It is fortified with conditioners which prevent dryness, moisturize the hair, protect hair against harsh ingredients, shield from environmental insults, and offer anti-irritant properties.</li>
                  <li>It therapeutically relieves itching and flaking associated with dandruff, seborrheic dermatitis, and psoriasis of the scalp.</li>
                </ul>


              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">eStaar ?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>eStaar solution is fortified with Milk Protein and Cococin which nourishes and moisturizes the scalp.</li>
                    <li>It helps to control scalp build-up, relieve scalp itch, restore moisture, and comfort irritated skin.</li>
                  </ul>


                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Before applying this medicine, wet the hair and scalp with lukewarm water.</li>
                      <li>Apply enough medicine to work up a lather and rub well into the scalp for 5 minutes, then rinse.</li>
                      <li>Apply the medicine again and rinse thoroughly.</li>
                    </ol>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Coal Tar 4.25%:</strong> Inhibits keratinocyte proliferation. Offers antimicrobial, anti-inflammatory and anti-pruritic effects.</li>
                      <li><strong>Salicylic Acid 2%:</strong> Acts as an exfoliator that promotes shedding of psoriatic scales without affecting epidermal structure.</li>
                      <li><strong>Benzalkonium Chloride 0.40%:</strong> Anti-inflammatory, anti-septic and anti-bacterial effects.</li>
                      <li><strong>Milk Protein:</strong> Offers anti-irritant properties, moisturizes, and provides optimum balance of nutrients to hair.</li>
                      <li><strong>Cococin:</strong> Freeze-dried coconut water solids with high nourishment factor.</li>
                    </ul>

                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
